<template>
  <section class="dash-section" aria-labelledby="dash-ops-heading">
    <div class="dash-section__head">
      <div>
        <h2 id="dash-ops-heading" class="dash-section__title">AI Operations</h2>
        <p class="dash-section__subtitle">Real-time performance across your AI call agent</p>
      </div>
      <v-btn
        icon="mdi-refresh"
        variant="text"
        class="dash-refresh-btn"
        :loading="loading"
        aria-label="Refresh dashboard"
        @click="$emit('refresh')"
      />
    </div>

    <div v-if="loading && !metrics.length" class="dash-metrics-grid dash-metrics-grid--skeleton">
      <div v-for="n in 6" :key="n" class="dash-metric dash-metric--skeleton" />
    </div>

    <div v-else class="dash-metrics-grid" role="list">
      <article
        v-for="metric in metrics"
        :key="metric.key"
        class="dash-metric"
        role="listitem"
      >
        <div class="dash-metric__icon-wrap">
          <v-icon :icon="metric.icon" size="20" />
        </div>
        <div class="dash-metric__body">
          <span class="dash-metric__label">{{ metric.label }}</span>
          <span class="dash-metric__value">{{ metric.value }}</span>
        </div>
        <span
          v-if="metric.trend"
          class="dash-metric__trend"
          :class="{
            'dash-metric__trend--up': metric.trendUp === true,
            'dash-metric__trend--down': metric.trendUp === false,
          }"
        >
          {{ metric.trend }}
        </span>
      </article>
    </div>
  </section>
</template>

<script setup>
defineOptions({ name: 'DashboardOperationsGrid' })

defineProps({
  metrics: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
})

defineEmits(['refresh'])
</script>
